module.exports = __webpack_public_path__ + "static/media/new.85642536.png";